module.exports = __webpack_public_path__ + "img/publicfoldersunset.a751d4d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_logos/publicfoldersunset.svg
// module id = QeKk
// module chunks = 0